import { render, staticRenderFns } from "./contracts.vue?vue&type=template&id=b9844a66&scoped=true&"
import script from "./contracts.vue?vue&type=script&lang=js&"
export * from "./contracts.vue?vue&type=script&lang=js&"
import style0 from "./contracts.vue?vue&type=style&index=0&id=b9844a66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9844a66",
  null
  
)

export default component.exports